const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");
const ViewPage = () => import("./_pages/view.vue");

export default [
  {
    path: "/drivers",
    component: Index,
  },
  {
    path: "/new-driver",
    component: CreatePage,
  },
  {
    path: "/driver/:id",
    component: ViewPage,
  },
];
